function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const colors = {
  error: "var(--notification-error)",
  warning: "var(--notification-warning)",
  information: "var(--notification-information)",
  info: "var(--notification-information)",
  success: "var(--notification-success)",
  text: "var(--icon-secondary)",
  disabled: "var(--icon-primary-disabled)",
  "on-color": "var(--icon-reversed)"
};
const resolveParams = (color, size, style) => {
  const colorResolved = colors[color];
  let result = {
    ...style
  };
  if (colorResolved) {
    result["--icon-primary"] = colorResolved;
    result["--icon-2colors-stroke"] = colorResolved;
    if (color === "disabled") {
      //only for 2-colors icon
      result["--icon-2colors-stroke"] = "var(--icon-2colors-stroke-disabled)";
      result["--chart-11"] = "var(--icon-2colors-fill-disabled)";
    }
  }
  if (size) {
    result.height = size;
    result.width = size;
  }
  return result;
};
export const AddIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add"
}, "Add"), /*#__PURE__*/React.createElement("path", {
  d: "M11.25 4.75C11.25 4.33578 11.5858 4 12 4C12.4142 4 12.75 4.33578 12.75 4.75V11.25H19.25C19.6642 11.25 20 11.5858 20 12C20 12.4142 19.6642 12.75 19.25 12.75H12.75V19.25C12.75 19.6642 12.4142 20 12 20C11.5858 20 11.25 19.6642 11.25 19.25V12.75H4.75C4.33582 12.75 4 12.4142 4 12C4 11.5858 4.33582 11.25 4.75 11.25H11.25V4.75Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const AddCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add-circle"
}, "Add circle"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_128)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.25 6.75C11.25 6.33578 11.5858 6 12 6C12.4142 6 12.75 6.33578 12.75 6.75V11.25H17.25C17.6642 11.25 18 11.5858 18 12C18 12.4142 17.6642 12.75 17.25 12.75H12.75V17.25C12.75 17.6642 12.4142 18 12 18C11.5858 18 11.25 17.6642 11.25 17.25V12.75H6.75C6.33582 12.75 6 12.4142 6 12C6 11.5858 6.33582 11.25 6.75 11.25H11.25V6.75Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12ZM1.5 12C1.5 17.799 6.20101 22.5 12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_128"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const AddRemoveColumnIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Add-remove-column"
}, "Add remove column"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20 3.7H4C3.83432 3.7 3.7 3.83431 3.7 4V20C3.7 20.1657 3.83431 20.3 4 20.3H20C20.1657 20.3 20.3 20.1657 20.3 20V4C20.3 3.83432 20.1657 3.7 20 3.7ZM4 2C2.89543 2 2 2.89543 2 4V20C2 21.1046 2.89543 22 4 22H20C21.1046 22 22 21.1046 22 20V4C22 2.89543 21.1046 2 20 2H4Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M7.99995 20.3L7.99995 3.7H9.69995L9.69995 20.3H7.99995Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 20.3L14 3.7H15.7L15.7 20.3H14Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const AdjustmentIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Adjustment"
}, "Adjustment"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.25 1.75C11.25 1.33579 11.5858 1 12 1C12.4142 1 12.75 1.33579 12.75 1.75V14.087C14.1834 14.4255 15.25 15.7132 15.25 17.25C15.25 18.7868 14.1834 20.0745 12.75 20.413V22.25C12.75 22.6642 12.4142 23 12 23C11.5858 23 11.25 22.6642 11.25 22.25V20.413C9.81665 20.0745 8.75 18.7868 8.75 17.25C8.75 15.7132 9.81665 14.4255 11.25 14.087V1.75ZM13.75 17.25C13.75 18.2165 12.9665 19 12 19C11.0335 19 10.25 18.2165 10.25 17.25C10.25 16.2835 11.0335 15.5 12 15.5C12.9665 15.5 13.75 16.2835 13.75 17.25Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 10.25C8.25 11.7868 7.18335 13.0745 5.75 13.413V22.25C5.75 22.6642 5.41421 23 5 23C4.58579 23 4.25 22.6642 4.25 22.25V13.413C2.81665 13.0745 1.75 11.7868 1.75 10.25C1.75 8.71321 2.81665 7.42555 4.25 7.08697V1.75C4.25 1.33579 4.58579 1 5 1C5.41421 1 5.75 1.33579 5.75 1.75V7.08697C7.18335 7.42555 8.25 8.71321 8.25 10.25ZM6.75 10.25C6.75 11.2165 5.9665 12 5 12C4.0335 12 3.25 11.2165 3.25 10.25C3.25 9.2835 4.0335 8.5 5 8.5C5.9665 8.5 6.75 9.2835 6.75 10.25Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.75 10.413C21.1833 10.0745 22.25 8.78679 22.25 7.25C22.25 5.71321 21.1833 4.42555 19.75 4.08697V1.75C19.75 1.33579 19.4142 1 19 1C18.5858 1 18.25 1.33579 18.25 1.75V4.08697C16.8166 4.42555 15.75 5.71321 15.75 7.25C15.75 8.78679 16.8166 10.0745 18.25 10.413V22.25C18.25 22.6642 18.5858 23 19 23C19.4142 23 19.75 22.6642 19.75 22.25V10.413ZM19 9C19.9665 9 20.75 8.2165 20.75 7.25C20.75 6.2835 19.9665 5.5 19 5.5C18.0335 5.5 17.25 6.2835 17.25 7.25C17.25 8.2165 18.0335 9 19 9Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const BackupIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Backup"
}, "Backup"), /*#__PURE__*/React.createElement("path", {
  d: "M21.4283 11.5C21.4283 7.10411 17.7927 3.54054 13.3079 3.54054C9.14043 3.54054 5.70621 6.61768 5.2411 10.5804L7.5144 8.9565C7.82305 8.73603 8.25058 8.82528 8.46937 9.15585C8.68811 9.48644 8.61524 9.93315 8.30659 10.1536L4.82186 12.6424L4.81898 12.645C4.7058 12.7462 4.56885 12.8004 4.42926 12.8096C4.19164 12.8279 3.94828 12.7148 3.80032 12.4912L1.1732 9.30878C0.921739 9.00449 0.947076 8.55068 1.22976 8.29514C1.51243 8.03954 1.94537 8.07904 2.19683 8.38332L3.70466 10.2081C4.34766 5.57253 8.40214 2 13.3079 2C18.6607 2 23 6.25329 23 11.5C23 16.7467 18.6607 21 13.3079 21C11.5385 21 9.87973 20.535 8.4521 19.7234C8.08599 19.5152 7.99297 19.048 8.22239 18.6994C8.46308 18.3336 8.964 18.2404 9.35159 18.4527C10.5224 19.0942 11.8716 19.4595 13.3079 19.4595C17.7927 19.4595 21.4283 15.8959 21.4283 11.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const CalculateIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Calculate"
}, "Calculate"), /*#__PURE__*/React.createElement("path", {
  d: "M14.3835 6.13335C14.0797 6.13335 13.8335 6.37959 13.8335 6.68335V7.05037C13.8335 7.35413 14.0797 7.60037 14.3835 7.60037H19.8834C20.1872 7.60037 20.4334 7.35413 20.4334 7.05037V6.68335C20.4334 6.37959 20.1872 6.13335 19.8834 6.13335H14.3835Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.1329 9.61675C6.1329 9.92051 6.37915 10.1667 6.68291 10.1667H7.04993C7.35369 10.1667 7.59993 9.9205 7.59993 9.61675V7.6002H9.61638C9.92014 7.6002 10.1664 7.35395 10.1664 7.0502V6.68318C10.1664 6.37942 9.92014 6.13318 9.61638 6.13318H7.59993V4.11667C7.59993 3.81292 7.35369 3.56667 7.04993 3.56667H6.68291C6.37915 3.56667 6.1329 3.81292 6.1329 4.11667V6.13318H4.11641C3.81265 6.13318 3.56641 6.37942 3.56641 6.68318V7.0502C3.56641 7.35395 3.81265 7.6002 4.11641 7.6002H6.1329V9.61675Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.1329 14.3834C6.1329 14.0797 6.37915 13.8334 6.6829 13.8334H7.04993C7.35369 13.8334 7.59993 14.0797 7.59993 14.3834V15.1169C7.59993 15.4207 7.35369 15.6669 7.04993 15.6669H6.6829C6.37915 15.6669 6.1329 15.4207 6.1329 15.1169V14.3834Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.6829 18.6001C6.37915 18.6001 6.1329 18.8463 6.1329 19.1501V19.8836C6.1329 20.1873 6.37915 20.4336 6.6829 20.4336H7.04993C7.35369 20.4336 7.59993 20.1873 7.59993 19.8836V19.1501C7.59993 18.8463 7.35369 18.6001 7.04993 18.6001H6.6829Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.56657 16.9501C3.56657 16.6463 3.81282 16.4001 4.11657 16.4001H9.61649C9.92025 16.4001 10.1665 16.6463 10.1665 16.9501V17.317C10.1665 17.6208 9.92025 17.867 9.61649 17.867H4.11657C3.81282 17.867 3.56657 17.6208 3.56657 17.317V16.9501Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.5775 14.6528C18.7923 14.4379 19.1406 14.4378 19.3555 14.6527L19.6149 14.9121C19.8297 15.1269 19.8297 15.4752 19.6149 15.69L18.1704 17.1345L19.6147 18.5781C19.8296 18.7929 19.8297 19.1412 19.6148 19.3561L19.3555 19.6154C19.1406 19.8303 18.7923 19.8302 18.5775 19.6153L17.134 18.1709L15.6894 19.6155C15.4746 19.8303 15.1263 19.8303 14.9115 19.6155L14.6521 19.3561C14.4373 19.1412 14.4373 18.7929 14.6522 18.5781L16.0966 17.1345L14.652 15.69C14.4372 15.4752 14.4372 15.1269 14.652 14.9121L14.9115 14.6526C15.1263 14.4378 15.4746 14.4378 15.6894 14.6526L17.134 16.0971L18.5775 14.6528Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.8 1H3.20002C1.98665 1 1 1.98665 1 3.20001V20.8C1 22.0133 1.98665 23 3.20002 23H20.8C22.0134 23 23 22.0133 23 20.8V3.20001C23 1.98665 22.0134 1 20.8 1ZM21.534 3.20001V11.2672L12.734 11.2661V2.46616H20.8012C21.2049 2.46616 21.534 2.79522 21.534 3.20001ZM3.19989 2.46599H11.2671V11.266L2.466 11.267V3.19985C2.466 2.79507 2.79509 2.46599 3.19989 2.46599ZM2.46587 20.8001V12.7341H11.2658V21.534H3.19975C2.79496 21.534 2.46587 21.2049 2.46587 20.8001ZM20.8 21.5341H12.7339V12.7342H21.5339V20.8013C21.5339 21.205 21.2048 21.5341 20.8 21.5341Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ChatIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Chat"
}, "Chat"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_88)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23.5C14.1505 23.5 16.1632 22.9097 17.8848 21.8823L21.834 22.9594C22.8295 23.2309 23.7067 22.2473 23.3235 21.2892L21.9297 17.8047C22.9278 16.1009 23.5 14.1173 23.5 12C23.5 5.64873 18.3513 0.5 12 0.5C5.64873 0.5 0.5 5.64873 0.5 12C0.5 18.3513 5.64873 23.5 12 23.5ZM20.2569 17.6429C21.3567 16.0368 22 14.0935 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C14.0759 22 16.004 21.3675 17.6022 20.2846L21.7443 21.3801L20.2569 17.6429Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_88"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const CloseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Close"
}, "Close"), /*#__PURE__*/React.createElement("path", {
  d: "M16.7842 7.21583C16.4793 6.91098 15.9644 6.93155 15.6341 7.26183L12 10.896L8.36587 7.26184C8.03559 6.93156 7.52068 6.91099 7.21583 7.21584C6.91098 7.52069 6.93155 8.0356 7.26183 8.36588L10.896 12L7.26183 15.6341C6.93155 15.9644 6.91098 16.4793 7.21583 16.7842C7.52068 17.089 8.03559 17.0684 8.36587 16.7382L12 13.104L15.6341 16.7382C15.9644 17.0685 16.4793 17.089 16.7842 16.7842C17.089 16.4793 17.0685 15.9644 16.7382 15.6341L13.104 12L16.7382 8.36587C17.0684 8.03559 17.089 7.52068 16.7842 7.21583Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const CollapseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Collapse"
}, "Collapse"), /*#__PURE__*/React.createElement("path", {
  d: "M21.3204 2.7743C21.0084 2.46235 20.509 2.45602 20.2048 2.76017L14.6999 8.26511L14.5778 4.29919C14.5732 3.86355 14.2164 3.50513 13.7807 3.49863C13.3451 3.49213 12.9956 3.84001 13.0001 4.27565L13.0603 10.0601C13.0628 10.2989 13.1711 10.5146 13.3404 10.6617C13.4868 10.8315 13.7019 10.9408 13.9407 10.9444L19.7255 11.0307C20.1611 11.0372 20.5106 10.6893 20.5061 10.2537C20.5016 9.81803 20.1447 9.4596 19.7091 9.4531L15.8291 9.39521L21.3345 3.88985C21.6387 3.5857 21.6323 3.08625 21.3204 2.7743Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.67962 21.2259C2.99158 21.5379 3.49102 21.5442 3.79518 21.2401L9.30011 15.7351L9.42222 19.701C9.42675 20.1367 9.7836 20.4951 10.2193 20.5016C10.6549 20.5081 11.0044 20.1602 10.9999 19.7246L10.9397 13.9401C10.9372 13.7013 10.8289 13.4857 10.6596 13.3385C10.5132 13.1687 10.2981 13.0594 10.0593 13.0559L4.27454 12.9695C3.83888 12.963 3.48938 13.3109 3.49391 13.7466C3.49844 14.1822 3.85529 14.5406 4.29095 14.5471L8.17086 14.605L2.6655 20.1104C2.36135 20.4145 2.36767 20.914 2.67962 21.2259Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ConfigureIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Configure"
}, "Configure"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.5717 6.64311C21.536 6.63518 21.4698 6.64175 21.408 6.70355L18.7336 9.37796C18.1012 10.0104 17.0759 10.0104 16.4435 9.37796L14.4805 7.41497C13.8481 6.78256 13.8481 5.75722 14.4805 5.12481L17.1549 2.4504C17.2167 2.38861 17.2232 2.32246 17.2153 2.28673C17.2116 2.26998 17.206 2.26425 17.2057 2.26397C17.2054 2.26364 17.2044 2.26258 17.2013 2.26091C17.1983 2.25926 17.1902 2.25532 17.1746 2.25195C15.3171 1.85257 13.3044 2.37488 11.8631 3.81615C10.2625 5.41683 9.79521 7.72317 10.4652 9.73691C10.6568 10.3125 10.5613 11.007 10.0778 11.4905L2.04819 19.5201C1.41578 20.1525 1.41578 21.1778 2.04819 21.8102C2.6806 22.4426 3.70593 22.4426 4.33834 21.8102L12.3679 13.7807C12.8514 13.2972 13.546 13.2017 14.1215 13.3932C16.1353 14.0632 18.4416 13.596 20.0423 11.9953C21.4835 10.554 22.0059 8.54131 21.6065 6.68385C21.6031 6.66818 21.5992 6.66009 21.5975 6.65708C21.5958 6.65404 21.5948 6.65302 21.5945 6.6527C21.5942 6.65242 21.5885 6.64683 21.5717 6.64311ZM21.8723 5.28801C22.3859 5.40194 22.8344 5.79141 22.9635 6.39207C23.4577 8.69067 22.8121 11.1885 21.0238 12.9768C19.0373 14.9632 16.1763 15.5397 13.6833 14.7102C13.531 14.6596 13.4083 14.7032 13.3494 14.7621L5.31984 22.7917C4.14537 23.9662 2.24117 23.9662 1.06669 22.7917C-0.107781 21.6173 -0.107782 19.7131 1.06669 18.5386L9.09628 10.509C9.15518 10.4501 9.19886 10.3274 9.1482 10.1751C8.31869 7.68212 8.89521 4.8211 10.8817 2.83466C12.67 1.04634 15.1678 0.400682 17.4664 0.894918C18.067 1.02407 18.4565 1.47254 18.5704 1.98611C18.6812 2.48548 18.5333 3.03501 18.1364 3.4319L15.462 6.1063C15.3716 6.19665 15.3716 6.34313 15.462 6.43347L17.425 8.39646C17.5153 8.4868 17.6618 8.4868 17.7521 8.39646L20.4265 5.72205C20.8234 5.32517 21.373 5.17723 21.8723 5.28801Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const CopyReplicateIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Copy-replicate"
}, "Copy replicate"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M3.5 8.5V20.5H15.5V8.5H3.5ZM3 7C2.44772 7 2 7.44772 2 8V21C2 21.5523 2.44772 22 3 22H16C16.5523 22 17 21.5523 17 21V8C17 7.44772 16.5523 7 16 7H3Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.5 7V3.5H20.5V15.5H17V17H21C21.5523 17 22 16.5523 22 16V3C22 2.44772 21.5523 2 21 2H8C7.44772 2 7 2.44772 7 3V7H8.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DeleteIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Delete"
}, "Delete"), /*#__PURE__*/React.createElement("path", {
  d: "M9.75006 8.75C10.1643 8.75 10.5001 9.08579 10.5001 9.5V18C10.5001 18.4142 10.1643 18.75 9.75006 18.75C9.33584 18.75 9.00006 18.4142 9.00006 18V9.5C9.00006 9.08579 9.33584 8.75 9.75006 8.75Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.7501 8.75C15.1643 8.75 15.5001 9.08579 15.5001 9.5V18C15.5001 18.4142 15.1643 18.75 14.7501 18.75C14.3358 18.75 14.0001 18.4142 14.0001 18V9.5C14.0001 9.08579 14.3358 8.75 14.7501 8.75Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.25 2C8.25 1.44772 8.69772 1 9.25 1H15.25C15.8023 1 16.25 1.44772 16.25 2V4.25H21.75C22.1642 4.25 22.5 4.58579 22.5 5C22.5 5.41421 22.1642 5.75 21.75 5.75H20.422C20.4383 5.86455 20.4436 5.98253 20.4365 6.10277L19.5541 21.1028C19.4997 22.0277 18.7337 22.75 17.8072 22.75H6.69296C5.76638 22.75 5.00039 22.0277 4.94598 21.1028L4.06363 6.10276C4.05656 5.98253 4.06176 5.86455 4.07814 5.75H2.75C2.33579 5.75 2 5.41421 2 5C2 4.58579 2.33579 4.25 2.75 4.25H8.25V2ZM9.75 4.2V2.5H14.75V4.2H9.75ZM5.81061 5.75H18.6895C18.8333 5.75 18.9475 5.87109 18.9391 6.01468L18.0567 21.0147C18.0489 21.1468 17.9395 21.25 17.8072 21.25H6.69296C6.56059 21.25 6.45117 21.1468 6.44339 21.0147L5.56104 6.01468C5.55259 5.87109 5.66677 5.75 5.81061 5.75Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DiscoverIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Discover"
}, "Discover"), /*#__PURE__*/React.createElement("path", {
  d: "M9.31282 7.76068C9.31282 7.3457 9.6512 7.00929 10.0685 7.00929C10.4859 7.00929 10.8242 7.3457 10.8242 7.76068V10.2653H13.3433C13.7606 10.2653 14.099 10.6017 14.099 11.0167C14.099 11.4317 13.7606 11.7681 13.3433 11.7681H10.8242V14.2728C10.8242 14.6877 10.4859 15.0242 10.0685 15.0242C9.6512 15.0242 9.31282 14.6877 9.31282 14.2728V11.7681H6.79379C6.37645 11.7681 6.03808 11.4317 6.03808 11.0167C6.03808 10.6017 6.37645 10.2653 6.79379 10.2653H9.31282V7.76068Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.7997 15.732C18.6479 14.3601 19.1371 12.7452 19.1371 11.0167C19.1371 6.03692 15.077 2 10.0685 2C5.06012 2 1 6.03692 1 11.0167C1 15.9965 5.06012 20.0334 10.0685 20.0334C12.6294 20.0334 14.9423 18.9781 16.5913 17.2809C16.6279 17.3238 16.6686 17.3643 16.7134 17.4017L21.3447 21.2656C21.771 21.6212 22.4065 21.566 22.7642 21.1421C23.1219 20.7182 23.0663 20.0863 22.64 19.7307L18.0088 15.8668C17.9434 15.8122 17.8732 15.7674 17.7997 15.732ZM10.0685 18.5307C14.2422 18.5307 17.6256 15.1666 17.6256 11.0167C17.6256 6.86689 14.2422 3.50279 10.0685 3.50279C5.89486 3.50279 2.51142 6.86689 2.51142 11.0167C2.51142 15.1666 5.89486 18.5307 10.0685 18.5307Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DislikeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Dislike"
}, "Dislike"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M20.7269 3.12603C20.4369 2.87705 20.0655 2.74324 19.6833 2.75L19.67 2.75023L17.75 2.75012V12.2501H19.6833C20.0655 12.2569 20.4369 12.1232 20.7269 11.8742C21.0054 11.6351 21.1904 11.3059 21.25 10.9447V4.05557C21.1904 3.69438 21.0054 3.3651 20.7269 3.12603ZM16.25 12.841L12.5343 21.2014C12.1112 21.1119 11.7194 20.9015 11.409 20.5911C10.9871 20.1692 10.75 19.5969 10.75 19.0001V15.0001C10.75 14.5859 10.4142 14.2501 10 14.2501H4.34L4.33151 14.2502C4.15031 14.2522 3.97084 14.2149 3.80552 14.1407C3.64021 14.0665 3.493 13.9572 3.3741 13.8205C3.25519 13.6837 3.16744 13.5228 3.11692 13.3488C3.06645 13.1749 3.05434 12.9922 3.08143 12.8132C3.0814 12.8133 3.08146 12.813 3.08143 12.8132L4.46152 3.81257C4.50672 3.5145 4.65813 3.24282 4.88783 3.04757C5.11754 2.85232 5.41007 2.74666 5.71152 2.75007L16.25 2.75012V12.841ZM19.6638 1.25012C20.411 1.23863 21.1367 1.50099 21.7039 1.98784C22.2729 2.47622 22.6427 3.15652 22.7432 3.89959C22.7477 3.93291 22.75 3.96649 22.75 4.00012V11.0001C22.75 11.0337 22.7477 11.0673 22.7432 11.1006C22.6427 11.8437 22.2729 12.524 21.7039 13.0124C21.1367 13.4992 20.411 13.7616 19.6638 13.7501H17.4874L13.6854 22.3047C13.565 22.5756 13.2964 22.7501 13 22.7501C12.0054 22.7501 11.0516 22.355 10.3483 21.6518C9.64509 20.9485 9.25 19.9947 9.25 19.0001V15.7501H4.34395C3.94687 15.754 3.55365 15.6718 3.19133 15.5091C2.82763 15.3459 2.50377 15.1056 2.24219 14.8047C1.9806 14.5039 1.78755 14.1498 1.6764 13.767C1.56525 13.3841 1.53867 12.9817 1.59849 12.5876L2.97848 3.58767C2.97844 3.58788 2.97851 3.58745 2.97848 3.58767C3.07805 2.93218 3.41118 2.33406 3.91636 1.90466C4.42055 1.4761 5.06232 1.24374 5.7239 1.25012H19.6638Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DownloadIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Download"
}, "Download"), /*#__PURE__*/React.createElement("path", {
  d: "M11.7123 2C11.3152 2 10.9934 2.31382 10.9934 2.70094L10.9934 15.6076L7.72843 12.498C7.44831 12.2236 6.99311 12.2226 6.71173 12.4957C6.43034 12.7689 6.42931 13.2127 6.70943 13.487L11.0922 17.7934C11.2458 17.9438 11.452 18.012 11.6533 17.998C11.8546 18.0129 12.061 17.9455 12.2153 17.7958L16.4516 13.6693C16.733 13.3961 16.734 12.9523 16.4539 12.678C16.1738 12.4036 15.7186 12.4026 15.4372 12.6757L12.4312 15.6081L12.4312 2.70094C12.4312 2.31382 12.1093 2 11.7123 2Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2 21.75C2 21.3358 2.33579 21 2.75 21H21.25C21.6642 21 22 21.3358 22 21.75C22 22.1642 21.6642 22.5 21.25 22.5H2.75C2.33579 22.5 2 22.1642 2 21.75Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const DuplicateIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Duplicate"
}, "Duplicate"), /*#__PURE__*/React.createElement("path", {
  d: "M9.5 10.5C9.08582 10.5 8.75 10.8358 8.75 11.25V13.75H6.25C5.83582 13.75 5.5 14.0858 5.5 14.5C5.5 14.9142 5.83582 15.25 6.25 15.25H8.75V17.75C8.75 18.1642 9.08582 18.5 9.5 18.5C9.91418 18.5 10.25 18.1642 10.25 17.75V15.25H12.75C13.1642 15.25 13.5 14.9142 13.5 14.5C13.5 14.0858 13.1642 13.75 12.75 13.75H10.25V11.25C10.25 10.8358 9.91418 10.5 9.5 10.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17 17V21C17 21.5523 16.5523 22 16 22H3C2.44772 22 2 21.5523 2 21V8C2 7.44772 2.44772 7 3 7H7V3C7 2.44772 7.44772 2 8 2H21C21.5523 2 22 2.44772 22 3V16C22 16.5523 21.5523 17 21 17H17ZM8.5 3.5V7H16C16.5523 7 17 7.44772 17 8V15.5H20.5V3.5H8.5ZM3.5 20.5V8.5H15.5V20.5H3.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const EditIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Edit"
}, "Edit"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_115)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.2929 1.70711L3.33976 15.6602C3.21593 15.7841 3.12679 15.9382 3.08126 16.1073L1.50139 21.9747C1.30041 22.721 1.93583 23.3564 2.68218 23.1555L8.54951 21.5756C8.71861 21.5301 8.87279 21.4409 8.99661 21.3171L22.9497 7.36396C23.3403 6.97342 23.3403 6.34028 22.9497 5.94975L18.7071 1.70711C18.3166 1.31658 17.6834 1.31657 17.2929 1.70711ZM4.91852 16.2028L18 3.12132L21.5355 6.65685L8.45406 19.7383L4.91852 16.2028ZM4.23229 17.6379L3.20544 21.4514L7.01898 20.4246L4.23229 17.6379Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_115"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const ExpandIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Expand"
}, "Expand"), /*#__PURE__*/React.createElement("path", {
  d: "M13.4543 10.4689C13.7662 10.7808 14.2657 10.7872 14.5698 10.483L20.0748 4.97807L20.1969 8.94398C20.2014 9.37962 20.5583 9.73804 20.9939 9.74454C21.4296 9.75105 21.7791 9.40316 21.7745 8.96752L21.7144 3.18306C21.7119 2.94423 21.6035 2.72861 21.4343 2.58146C21.2879 2.41166 21.0728 2.30237 20.834 2.29881L15.0492 2.21249C14.6135 2.20599 14.264 2.55387 14.2686 2.98951C14.2731 3.42515 14.6299 3.78357 15.0656 3.79007L18.9455 3.84796L13.4402 9.35332C13.136 9.65747 13.1423 10.1569 13.4543 10.4689Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.5458 13.5313C10.2339 13.2193 9.7344 13.213 9.43025 13.5172L3.92532 19.0221L3.80321 15.0562C3.79868 14.6206 3.44183 14.2621 3.00617 14.2556C2.5705 14.2491 2.22101 14.597 2.22554 15.0326L2.28571 20.8171C2.2882 21.0559 2.39658 21.2716 2.56578 21.4187C2.71218 21.5885 2.9273 21.6978 3.1661 21.7014L8.95089 21.7877C9.38655 21.7942 9.73605 21.4463 9.73152 21.0107C9.72699 20.575 9.37014 20.2166 8.93448 20.2101L5.05456 20.1522L10.5599 14.6468C10.8641 14.3427 10.8578 13.8432 10.5458 13.5313Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const FilterIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Filter"
}, "Filter"), /*#__PURE__*/React.createElement("path", {
  d: "M2 7.09995C2 6.60289 2.40294 6.19995 2.9 6.19995H21.1C21.5971 6.19995 22 6.60289 22 7.09995C22 7.59701 21.5971 7.99995 21.1 7.99995H2.9C2.40294 7.99995 2 7.59701 2 7.09995Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M5 12.1C5 11.6029 5.40294 11.2 5.9 11.2H18.1C18.5971 11.2 19 11.6029 19 12.1C19 12.597 18.5971 13 18.1 13L5.9 13C5.40294 13 5 12.597 5 12.1Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.9 16.2C8.40294 16.2 8 16.6029 8 17.1C8 17.597 8.40294 18 8.9 18H15.1C15.5971 18 16 17.597 16 17.1C16 16.6029 15.5971 16.2 15.1 16.2H8.9Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const FilterOnIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Filter-on"
}, "Filter on"), /*#__PURE__*/React.createElement("path", {
  d: "M9.77778 17.6666C9.77778 18.2189 10.2255 18.6666 10.7778 18.6666H11.4444C11.9967 18.6666 12.4444 18.2189 12.4444 17.6666V17.4444C12.4444 16.8921 11.9967 16.4444 11.4444 16.4444H10.7778C10.2255 16.4444 9.77778 16.8921 9.77778 17.4444V17.6666ZM3 5.33325C2.44772 5.33325 2 5.78097 2 6.33325V6.55547C2 7.10776 2.44772 7.55547 3 7.55547H21C21.5523 7.55547 22 7.10776 22 6.55547V6.33325C22 5.78097 21.5523 5.33325 21 5.33325H3ZM6.33333 13.111C5.78105 13.111 5.33333 12.6633 5.33333 12.111V11.8888C5.33333 11.3365 5.78105 10.8888 6.33333 10.8888H17.6667C18.219 10.8888 18.6667 11.3365 18.6667 11.8888V12.111C18.6667 12.6633 18.219 13.111 17.6667 13.111H6.33333ZM21.1409 13.9308C21.4641 13.6023 21.9937 13.6018 22.3174 13.9299C22.6344 14.2512 22.6347 14.7674 22.3182 15.089L18.1973 19.2768C17.806 19.6745 17.165 19.675 16.773 19.278L14.5723 17.0493C14.255 16.728 14.2547 16.2113 14.5718 15.8896C14.8948 15.5618 15.4234 15.5614 15.747 15.8886L16.7728 16.926C17.165 17.3225 17.8057 17.3216 18.1968 16.924L21.1409 13.9308Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const HideIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Hide"
}, "Hide"), /*#__PURE__*/React.createElement("path", {
  d: "M17.4679 6.23425C15.7815 5.38028 13.9034 4.95295 11.9999 5.00001C9.65034 4.94192 7.33955 5.60664 5.37996 6.90433C3.42038 8.20202 1.90648 10.0701 1.04293 12.256C0.985689 12.4133 0.985689 12.5857 1.04293 12.743C1.71332 14.4407 2.77601 15.9468 4.13514 17.1429L5.33757 16.1591C4.16548 15.17 3.23332 13.919 2.62093 12.5C3.40726 10.6783 4.72058 9.13354 6.39197 8.06431C8.06336 6.99507 10.0164 6.45028 11.9999 6.50001C13.4361 6.46391 14.8562 6.7395 16.1651 7.30018L17.4679 6.23425Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.412 8.73452C13.6833 8.32383 12.8492 8.11826 11.9999 8.15101C10.7973 8.10437 9.83659 8.5356 8.95088 9.35048C8.06517 10.1654 7.76498 11.2977 7.71145 12.5C7.75469 13.017 7.83878 13.5187 7.99249 13.9869L9.35664 12.8707C9.31027 12.5097 9.33183 12.1415 9.42212 11.7853C9.56095 11.2376 9.85626 10.7422 10.272 10.3596C10.6877 9.97703 11.2058 9.72377 11.7631 9.63077C12.2378 9.55156 12.7233 9.59155 13.1766 9.74533L14.412 8.73452Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.1121 10.2719L15.2495 9.34136C15.253 9.34452 15.2564 9.34768 15.2598 9.35084C15.6304 9.69184 15.9382 10.0884 16.1748 10.5224L14.9751 11.504C14.8992 11.2957 14.7994 11.0958 14.6769 10.9084C14.52 10.6685 14.3294 10.4543 14.1121 10.2719Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M9.68757 13.892L8.43106 14.9201C8.58761 15.1625 8.77528 15.3889 8.99993 15.5955C9.15861 15.7415 9.31923 15.8757 9.48296 15.9975L10.7243 14.9819C10.6311 14.9249 10.5408 14.8624 10.4541 14.7948C10.138 14.5486 9.87764 14.2408 9.68757 13.892Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M11.8191 15.3782L10.4064 16.5341C10.8913 16.7397 11.4145 16.8477 11.9994 16.8477C13.1889 16.8477 14.335 16.4008 15.2104 15.5955C16.0859 14.7902 16.6268 13.6854 16.7259 12.5C16.7107 12.1569 16.6568 11.8195 16.567 11.4935L15.1394 12.6616C15.0668 13.4023 14.7242 14.0927 14.1738 14.5992C13.5834 15.1426 12.8018 15.4302 11.9999 15.399C11.9393 15.394 11.879 15.387 11.8191 15.3782Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.2055 9.33481C20.1241 10.2342 20.8644 11.3078 21.3789 12.5C20.5926 14.3217 19.2793 15.8665 17.6079 16.9357C15.9365 18.005 13.9835 18.5497 11.9999 18.5C10.8459 18.529 9.70221 18.3568 8.61828 17.9971L7.26432 19.1049C8.75431 19.732 10.3678 20.0404 11.9999 20C14.3495 20.0581 16.6603 19.3934 18.6199 18.0957C20.5795 16.798 22.0934 14.9299 22.9569 12.744C23.0142 12.5864 23.0142 12.4136 22.9569 12.256C22.377 10.7879 21.5036 9.46318 20.399 8.35833L19.2055 9.33481Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M18.401 6.7629L17.1487 7.78747C17.304 7.87538 17.4571 7.96762 17.608 8.06413C17.8986 8.25002 18.1783 8.45027 18.4463 8.66386L19.6538 7.67595C19.3251 7.40053 18.98 7.1428 18.6199 6.90433C18.5474 6.85632 18.4744 6.80917 18.401 6.7629Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M6.26811 18.6279L7.55508 17.5749C7.15508 17.3888 6.7664 17.1755 6.39186 16.9359C6.31271 16.8853 6.23437 16.8336 6.15684 16.7808L4.93169 17.7832C5.07825 17.8907 5.2276 17.9948 5.37963 18.0955C5.66849 18.2868 5.96499 18.4644 6.26811 18.6279Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M23.4749 3.58051C23.7372 3.9011 23.69 4.37361 23.3694 4.63591L2.53032 21.6861C2.20974 21.9483 1.73722 21.9011 1.47493 21.5805C1.21263 21.2599 1.25988 20.7874 1.58047 20.5251L22.4195 3.47497C22.7401 3.21268 23.2126 3.25993 23.4749 3.58051Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const LikeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Like"
}, "Like"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.3146 1.6954C10.435 1.42455 10.7036 1.25 11 1.25C11.9946 1.25 12.9484 1.64509 13.6517 2.34835C14.3549 3.05161 14.75 4.00544 14.75 5V8.25H19.6561C20.0532 8.24617 20.4464 8.32837 20.8087 8.49097C21.1724 8.6542 21.4962 8.89456 21.7578 9.19538C22.0194 9.4962 22.2125 9.8503 22.3236 10.2331C22.4347 10.616 22.4613 11.0184 22.4015 11.4125L21.0215 20.4125C21.0215 20.4125 21.0215 20.4124 21.0215 20.4125C20.9221 21.0681 20.589 21.6659 20.0836 22.0955C19.5794 22.524 18.9377 22.7564 18.2761 22.75H4C3.27065 22.75 2.57118 22.4603 2.05546 21.9445C1.53973 21.4288 1.25 20.7293 1.25 20V13C1.25 12.2707 1.53973 11.5712 2.05546 11.0555C2.57118 10.5397 3.27065 10.25 4 10.25H6.5126L10.3146 1.6954ZM7.75 11.1592L11.4657 2.79872C11.8888 2.88824 12.2806 3.09859 12.591 3.40901C13.0129 3.83097 13.25 4.40326 13.25 5V9C13.25 9.41421 13.5858 9.75 14 9.75H19.66L19.6685 9.74995C19.8497 9.7479 20.0292 9.78527 20.1945 9.85946C20.3598 9.93366 20.507 10.0429 20.6259 10.1796C20.7448 10.3164 20.8326 10.4773 20.8831 10.6514C20.9336 10.8253 20.9457 11.0081 20.9185 11.1871C20.9185 11.1872 20.9186 11.187 20.9185 11.1871L19.5385 20.1875C19.4933 20.4856 19.3419 20.7573 19.1122 20.9526C18.8825 21.1478 18.5899 21.2535 18.2885 21.25L7.75 21.25V11.1592ZM6.25 21.25V11.75H4C3.66848 11.75 3.35054 11.8817 3.11612 12.1161C2.8817 12.3505 2.75 12.6685 2.75 13V20C2.75 20.3315 2.8817 20.6495 3.11612 20.8839C3.35054 21.1183 3.66848 21.25 4 21.25H6.25Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const LinkIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Link"
}, "Link"), /*#__PURE__*/React.createElement("path", {
  d: "M14.3244 4.4198L12.1783 6.56594C11.8868 6.85739 11.4148 6.85903 11.1213 6.56961C10.8249 6.27733 10.8233 5.79961 11.1176 5.50528L13.2637 3.35914C15.0759 1.54695 18.014 1.54696 19.8262 3.35914C21.6384 5.17132 21.6384 8.10946 19.8262 9.92164L15.9512 13.7966C14.351 15.3969 11.8728 15.584 10.0672 14.3581C9.8276 14.1955 9.59738 13.9123 9.38708 13.6289C9.17194 13.3391 9.23098 12.923 9.51609 12.7016C9.8145 12.4699 10.2547 12.5357 10.5343 12.7898C10.6012 12.8506 10.6695 12.9101 10.7379 12.9699C10.7883 13.0138 10.8387 13.0578 10.8888 13.1025C12.1124 13.9469 13.8018 13.8248 14.8906 12.736L18.7656 8.86098C19.992 7.63458 19.992 5.6462 18.7656 4.4198C17.5392 3.1934 15.5508 3.1934 14.3244 4.4198Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.86097 18.736L11.0071 16.5898C11.2986 16.2984 11.7706 16.2967 12.0641 16.5862C12.3604 16.8784 12.3621 17.3562 12.0678 17.6505L9.92164 19.7966C8.10945 21.6088 5.17132 21.6088 3.35914 19.7966C1.54695 17.9844 1.54695 15.0463 3.35914 13.2341L7.23414 9.35912C8.83436 7.7589 11.3125 7.57173 13.1181 8.79762C13.3578 8.96031 13.588 9.24347 13.7983 9.52682C14.0134 9.8167 13.9544 10.2327 13.6693 10.4542C13.3709 10.6859 12.9307 10.6201 12.6511 10.366C12.5842 10.3052 12.5159 10.2456 12.4474 10.1859C12.3971 10.142 12.3466 10.0979 12.2966 10.0533C11.073 9.20882 9.3836 9.33098 8.2948 10.4198L4.4198 14.2948C3.1934 15.5212 3.1934 17.5096 4.4198 18.736C5.6462 19.9624 7.63458 19.9624 8.86097 18.736Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const LoaderIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Loader"
}, "Loader"), /*#__PURE__*/React.createElement("path", {
  d: "M1.85 12C1.38056 12 0.996582 12.3819 1.03235 12.85C1.46626 18.5279 6.21087 23 12 23C18.0751 23 23 18.0751 23 12C23 6.21087 18.5279 1.46626 12.85 1.03235C12.3819 0.996582 12 1.38056 12 1.85C12 2.31944 12.3818 2.69594 12.8493 2.73826C17.5875 3.16724 21.3 7.15007 21.3 12C21.3 17.1362 17.1362 21.3 12 21.3C7.15007 21.3 3.16724 17.5875 2.73826 12.8493C2.69594 12.3818 2.31944 12 1.85 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const MoveIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Move"
}, "Move"), /*#__PURE__*/React.createElement("path", {
  d: "M5.49338 4.70094C5.49338 4.31382 5.81525 4 6.2123 4C6.60935 4 6.93122 4.31382 6.93122 4.70094L6.93122 17.6081L9.93726 14.6757C10.2187 14.4026 10.6739 14.4036 10.954 14.678C11.2341 14.9523 11.2331 15.3961 10.9517 15.6693L6.71528 19.7958C6.56105 19.9455 6.35459 20.0129 6.15336 19.998C5.95204 20.012 5.74584 19.9438 5.59227 19.7934L1.20942 15.487C0.929299 15.2127 0.930327 14.7689 1.21172 14.4957C1.49311 14.2226 1.9483 14.2236 2.22843 14.498L5.49338 17.6076L5.49338 4.70094Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.6699 19.2991C17.6699 19.6862 17.3481 20 16.951 20C16.554 20 16.2321 19.6862 16.2321 19.2991V6.39187L13.226 9.32426C12.9447 9.59738 12.4895 9.59638 12.2093 9.32202C11.9292 9.04767 11.9302 8.60386 12.2116 8.33074L16.448 4.20418C16.6023 4.05448 16.8087 3.98714 17.0099 4.00202C17.2113 3.98799 17.4175 4.05624 17.571 4.20665L21.9539 8.51297C22.234 8.78733 22.233 9.23114 21.9516 9.50425C21.6702 9.77737 21.215 9.77637 20.9349 9.50202L17.6699 6.39242V19.2991Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const OpenIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Open"
}, "Open"), /*#__PURE__*/React.createElement("path", {
  d: "M12.5788 14.8029C12.4454 14.9173 12.2769 14.983 12.103 15H11.897C11.7231 14.983 11.5546 14.9173 11.4212 14.8029L6.21983 10.1995C5.90651 9.93074 5.94766 9.52812 6.21983 9.22634C6.49199 8.92455 6.99915 8.92455 7.35442 9.22634L12.0021 13.3513L16.6456 9.22634C17.0009 8.92455 17.508 8.92455 17.7802 9.22634C18.0523 9.52812 18.0935 9.93074 17.7802 10.1995L12.5788 14.8029Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const OpenCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Open-circle"
}, "Open circle"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_181)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5788 14.8029C12.4454 14.9173 12.2769 14.983 12.103 15H11.897C11.7231 14.983 11.5546 14.9173 11.4212 14.8029L7.21983 11.1995C6.90651 10.9307 6.94766 10.5281 7.21983 10.2263C7.49199 9.92455 7.99915 9.92455 8.35442 10.2263L12.0021 13.3513L15.6456 10.2263C16.0009 9.92455 16.508 9.92455 16.7802 10.2263C17.0523 10.5281 17.0935 10.9307 16.7802 11.1995L12.5788 14.8029Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_181"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const OptimizeIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Optimize"
}, "Optimize"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_174)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M16.9803 9.21967C17.2732 9.51256 17.2732 9.98744 16.9803 10.2803L11.4803 15.7803C11.3356 15.925 11.1382 16.0043 10.9337 15.9998C10.7291 15.9954 10.5353 15.9076 10.3971 15.7568L7.39709 12.4841C7.1172 12.1787 7.13782 11.7043 7.44316 11.4244C7.7485 11.1445 8.22293 11.1651 8.50282 11.4705L10.9735 14.1658L15.9196 9.21967C16.2125 8.92678 16.6874 8.92678 16.9803 9.21967Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.9685 24H13.1132L13.103 23.9796C13.5626 23.9796 13.9506 23.6327 13.9915 23.2245L14.3285 21.051C15.1762 20.8265 15.9932 20.4898 16.6877 20L18.5157 21.3061C18.5872 21.347 18.6587 21.3878 18.7302 21.4082C18.914 21.4694 19.1183 21.4694 19.3021 21.4082C19.4247 21.3674 19.5268 21.2959 19.6187 21.2143L21.1506 19.6735C21.3345 19.5102 21.4468 19.2653 21.4468 19.0102C21.4468 18.847 21.3651 18.6327 21.263 18.4796L19.9966 16.6939C20.446 15.9388 20.7932 15.1327 20.9668 14.3164L23.0502 13.9592C23.3974 13.9694 23.7549 13.796 23.9183 13.4695C23.9694 13.3572 24 13.245 24 13.1225V10.898C24 10.694 23.9285 10.4899 23.7957 10.3266C23.6834 10.1838 23.4383 10.0409 23.2647 10.0001H23.234L21.0587 9.66335C20.834 8.81642 20.497 8.0001 20.017 7.31643L21.314 5.4797C21.4264 5.32664 21.4877 5.13277 21.4877 4.93889C21.4877 4.77563 21.406 4.53073 21.314 4.39808C21.2936 4.36747 21.2426 4.31645 21.2426 4.31645L19.7004 2.74503C19.6289 2.6634 19.5472 2.61238 19.4553 2.57156C19.2306 2.47972 19.0264 2.50013 18.9753 2.51034C18.8119 2.51034 18.6587 2.56136 18.526 2.65319L16.7489 3.91849C15.9728 3.46951 15.1353 3.13278 14.3183 2.96952L13.9506 0.79606C13.92 0.581775 13.8179 0.387899 13.6545 0.234839C13.5115 0.102187 13.2357 0.0103504 13.0519 0.0103504H10.9277C10.6723 -0.0304657 10.4272 0.0511664 10.2332 0.224635C10.1004 0.347083 9.98808 0.561367 9.94723 0.755244L9.53872 3.03074C8.70128 3.25523 7.89447 3.60217 7.22043 4.10216L5.45362 2.69401C5.32085 2.59197 5.17787 2.53074 5.00426 2.53074C4.98842 2.53074 4.96955 2.52983 4.94807 2.5288C4.84487 2.52383 4.68135 2.51595 4.50383 2.59197C4.41191 2.63278 4.32 2.69401 4.24851 2.76544L2.66553 4.36747C2.63489 4.38788 2.61447 4.41849 2.59404 4.4491C2.35915 4.77563 2.35915 5.2246 2.58383 5.53073L3.85021 7.33684C3.42128 8.09193 3.10468 8.90825 2.95149 9.70417L0.796596 10.0715C0.347234 10.1225 0 10.5103 0 10.9695V13.2041C0 13.6633 0.347234 14.0511 0.755745 14.0919L3.02298 14.4797C3.24766 15.3266 3.58468 16.1327 4.06468 16.8368L2.76766 18.6531C2.52255 18.9796 2.52255 19.4286 2.76766 19.7551C2.78809 19.7857 2.84936 19.847 2.84936 19.847L4.43234 21.347C4.52426 21.4286 4.6366 21.4898 4.74894 21.5204C4.89957 21.5622 5.02964 21.5561 5.10541 21.5525C5.12211 21.5517 5.13617 21.551 5.14723 21.551C5.31064 21.551 5.46383 21.5 5.5966 21.4082L7.39404 20.1021C8.12936 20.5306 8.91574 20.847 9.70213 21.0204L10.0698 23.1939C10.1209 23.6531 10.5089 24 10.9685 24ZM12.5821 22.4694H11.5098L11.5506 22.4592L11.2647 20.7755C11.2238 20.4898 11.0911 20.2245 10.897 20.0102C10.6928 19.7959 10.4374 19.6429 10.1719 19.5817C9.47745 19.4082 8.81362 19.1327 8.23149 18.7959C7.9966 18.6429 7.73106 18.5715 7.46553 18.5715C7.15915 18.5613 6.83234 18.6633 6.58723 18.847L5.15745 19.8674L4.36085 19.1123L5.37192 17.6939C5.53532 17.449 5.61702 17.1633 5.61702 16.8776C5.61702 16.5919 5.53532 16.3062 5.39234 16.1021C5.02468 15.4694 4.73872 14.7858 4.55489 14.1021C4.4834 13.7858 4.32 13.5103 4.08511 13.3062C3.85021 13.0919 3.55404 12.9695 3.28851 12.9388L1.57277 12.6531V11.4797L3.23745 11.194C3.53362 11.1531 3.79915 11.0307 4.01362 10.8266C4.22809 10.6327 4.38128 10.3776 4.44255 10.0919C4.61617 9.38784 4.8817 8.70417 5.21872 8.10214C5.3617 7.85724 5.4434 7.58173 5.4434 7.30622C5.4434 7.03072 5.3617 6.75521 5.18809 6.4797L4.17702 5.05114L4.98383 4.23481L6.37277 5.33685C6.85277 5.65317 7.53702 5.63277 7.96596 5.35726C8.59915 4.97971 9.27319 4.694 9.94723 4.51032C10.2536 4.43889 10.5294 4.27563 10.7438 4.04094C10.9481 3.80625 11.0809 3.51033 11.1013 3.25523L11.3974 1.53075H12.5515L12.8374 3.20421C12.8783 3.50012 13.0111 3.76543 13.2051 3.97971C13.3991 4.194 13.6545 4.34706 13.9302 4.40828C14.6553 4.58175 15.36 4.86746 15.983 5.2246C16.463 5.53072 17.0655 5.55113 17.617 5.2042L19.0162 4.2042L19.8026 5.01032L18.7711 6.45929C18.6179 6.69398 18.5362 6.96949 18.5362 7.2552C18.5362 7.54092 18.6179 7.81642 18.7506 8.03071C19.1285 8.66336 19.4145 9.34703 19.5983 10.0409C19.6698 10.3266 19.8128 10.5817 20.0272 10.7756C20.2417 10.9695 20.5072 11.1021 20.783 11.1429L22.4783 11.4286V12.5103L20.7319 12.8062C20.4357 12.847 20.1702 12.9797 19.9557 13.1735C19.7413 13.3776 19.5881 13.6327 19.5268 13.898C19.343 14.6123 19.057 15.2858 18.6894 15.9082C18.5464 16.1531 18.4647 16.4286 18.4647 16.7041C18.4647 16.9796 18.5464 17.2551 18.72 17.5307L19.7311 18.9592L18.9549 19.7347L17.5557 18.7347C17.0757 18.4388 16.4221 18.449 15.9728 18.7347C15.3396 19.1123 14.6655 19.398 13.9609 19.5817C13.6851 19.6531 13.4298 19.7959 13.2357 20.0102C13.0417 20.2245 12.9089 20.4898 12.8681 20.7653L12.5821 22.4694ZM3.84 4.63277L3.86043 4.65318C3.86043 4.65318 3.85021 4.63277 3.84 4.63277Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_174"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const PauseIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pause"
}, "Pause"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_15_402)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12ZM1.50018 12C1.50018 6.21038 6.21038 1.50018 12 1.50018C17.7896 1.50018 22.4998 6.21038 22.4998 12C22.4998 17.7896 17.7896 22.4998 12 22.4998C6.21038 22.4998 1.50018 17.7896 1.50018 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10 7.25C10.4142 7.25 10.75 7.58579 10.75 8V16C10.75 16.4142 10.4142 16.75 10 16.75C9.58579 16.75 9.25 16.4142 9.25 16V8C9.25 7.58579 9.58579 7.25 10 7.25Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14 7.25C14.4142 7.25 14.75 7.58579 14.75 8V16C14.75 16.4142 14.4142 16.75 14 16.75C13.5858 16.75 13.25 16.4142 13.25 16V8C13.25 7.58579 13.5858 7.25 14 7.25Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_15_402"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const PinIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pin"
}, "Pin"), /*#__PURE__*/React.createElement("path", {
  d: "M21.3385 9.33739C21.6446 9.64099 22.1386 9.63995 22.4435 9.33506C22.7504 9.02817 22.7491 8.53023 22.4407 8.22489L15.7026 1.55414C15.3967 1.25131 14.9007 1.26254 14.6088 1.57892C14.3321 1.87881 14.3415 2.34362 14.63 2.63214L15.0407 3.04286L6.01286 10.68L5.20879 9.8806C4.9056 9.57918 4.41623 9.57815 4.11178 9.87828C3.80397 10.1817 3.80177 10.6776 4.10685 10.9838L8.00071 14.8914L1.5544 21.3305C1.24795 21.6366 1.24693 22.133 1.55213 22.4403C1.85873 22.7491 2.35787 22.75 2.66556 22.4423L9.10857 15.9993L13.013 19.89C13.3206 20.1965 13.8191 20.1934 14.1228 19.8831C14.4224 19.5771 14.4198 19.0869 14.117 18.7841L13.32 17.9871L20.9571 8.95929L21.3385 9.33739ZM12.2043 16.8714L7.12857 11.7957L16.1564 4.14286L19.8571 7.84357L12.2043 16.8714Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const PlayIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Play"
}, "Play"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_195)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.60006 7.69799C9.59726 7.58108 9.62315 7.46527 9.67544 7.36068C9.72774 7.25609 9.80486 7.16589 9.90006 7.09799C9.98886 7.03797 10.0938 7.0064 10.201 7.00747C10.3082 7.00854 10.4125 7.04221 10.5001 7.10399L16.8361 11.328C16.9297 11.3975 17.0059 11.4879 17.0583 11.5921C17.1108 11.6963 17.1381 11.8113 17.1381 11.928C17.1381 12.0446 17.1108 12.1597 17.0583 12.2638C17.0059 12.368 16.9297 12.4585 16.8361 12.528L13.6691 14.628L10.5021 16.742C10.4138 16.8026 10.3092 16.8351 10.2021 16.8351C10.0949 16.8351 9.99036 16.8026 9.90206 16.742C9.80705 16.6739 9.73007 16.5837 9.6778 16.4791C9.62552 16.3746 9.59953 16.2589 9.60206 16.142L9.60006 7.69799ZM11.1001 9.30706L15.0291 11.9263L12.8401 13.3778L11.1013 14.5385L11.1001 9.30706Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M24 12C24 5.37259 18.6274 0 12 0C5.37259 0 0 5.37259 0 12C0 18.6274 5.37258 24 12 24C18.6274 24 24 18.6274 24 12ZM1.50018 12C1.50018 6.21038 6.21038 1.50018 12 1.50018C17.7896 1.50018 22.4998 6.21038 22.4998 12C22.4998 17.7896 17.7896 22.4998 12 22.4998C6.21038 22.4998 1.50018 17.7896 1.50018 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_195"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const PopInIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pop-in"
}, "Pop in"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.0989 3.95598C21.8272 3.95598 22.4176 4.54638 22.4176 5.27467V21.0989C22.4176 21.8272 21.8272 22.4176 21.0989 22.4176H5.2747C4.54641 22.4176 3.95602 21.8272 3.95602 21.0989V10.5494C3.95602 10.1124 3.60178 9.7582 3.16481 9.7582C2.72784 9.7582 2.3736 10.1124 2.3736 10.5494V21.0989C2.3736 22.7011 3.67247 24 5.2747 24H21.0989C22.7011 24 24 22.7011 24 21.0989V5.27467C24 3.67243 22.7011 2.37356 21.0989 2.37356H10.5494C10.1125 2.37356 9.75822 2.7278 9.75822 3.16477C9.75822 3.60175 10.1125 3.95598 10.5494 3.95598H21.0989Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.75822 12.6593C9.75822 11.0571 11.0571 9.7582 12.6593 9.7582H17.9341C19.5363 9.7582 20.8352 11.0571 20.8352 12.6593V17.934C20.8352 19.5363 19.5363 20.8352 17.9341 20.8352H12.6593C11.0571 20.8352 9.75822 19.5363 9.75822 17.934V12.6593ZM12.6593 11.3406C11.931 11.3406 11.3406 11.931 11.3406 12.6593V17.934C11.3406 18.6623 11.931 19.2527 12.6593 19.2527H17.9341C18.6623 19.2527 19.2527 18.6623 19.2527 17.934V12.6593C19.2527 11.931 18.6623 11.3406 17.9341 11.3406H12.6593Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.05733 7.08874L8.05733 1.02279C8.05733 0.585818 7.70309 0.231579 7.26612 0.231579C6.82915 0.231579 6.47491 0.585818 6.47491 1.02279L6.47491 5.17859L1.35068 0.23174C1.04169 -0.0772467 0.540726 -0.0772467 0.231739 0.23174C-0.0772464 0.540727 -0.0772465 1.04169 0.231739 1.35068L5.35597 6.29753H1.20018C0.763203 6.29753 0.408966 6.65176 0.408966 7.08874C0.408966 7.52571 0.763203 7.87994 1.20018 7.87994H7.26612C7.70309 7.87994 8.05733 7.52571 8.05733 7.08874Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const PopOutIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Pop-out"
}, "Pop out"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.80851 4.59574C2.10347 4.59574 1.53191 5.1673 1.53191 5.87234V21.1915C1.53191 21.8965 2.10347 22.4681 2.80851 22.4681H18.1277C18.8327 22.4681 19.4043 21.8965 19.4043 21.1915V13.0213C19.4043 12.5983 19.7472 12.2553 20.1702 12.2553C20.5932 12.2553 20.9362 12.5983 20.9362 13.0213V21.1915C20.9362 22.7426 19.6788 24 18.1277 24H2.80851C1.25741 24 0 22.7426 0 21.1915V5.87234C0 4.32124 1.25741 3.06383 2.80851 3.06383H10.9787C11.4017 3.06383 11.7447 3.40676 11.7447 3.82979C11.7447 4.25281 11.4017 4.59574 10.9787 4.59574H2.80851Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.2766 2.80851C13.2766 1.25741 14.534 0 16.0851 0H21.1915C22.7426 0 24 1.25741 24 2.80851V7.91489C24 9.46599 22.7426 10.7234 21.1915 10.7234H16.0851C14.534 10.7234 13.2766 9.46599 13.2766 7.91489V2.80851ZM16.0851 1.53191C15.3801 1.53191 14.8085 2.10347 14.8085 2.80851V7.91489C14.8085 8.61994 15.3801 9.19149 16.0851 9.19149H21.1915C21.8965 9.19149 22.4681 8.61994 22.4681 7.91489V2.80851C22.4681 2.10347 21.8965 1.53191 21.1915 1.53191H16.0851Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M10.609 12.4259H4.73668C4.31365 12.4259 3.97072 12.7688 3.97072 13.1918C3.97072 13.6149 4.31365 13.9578 4.73668 13.9578L8.75983 13.9578L3.97088 18.9185C3.67175 19.2176 3.67175 19.7026 3.97088 20.0017C4.27 20.3008 4.75498 20.3008 5.0541 20.0017L9.84306 15.041V19.0642C9.84306 19.4872 10.186 19.8301 10.609 19.8301C11.032 19.8301 11.375 19.4872 11.375 19.0642V13.1918C11.375 12.7688 11.032 12.4259 10.609 12.4259Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const RemoveIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Remove"
}, "Remove"), /*#__PURE__*/React.createElement("path", {
  d: "M17 11.75C17 11.3358 16.6642 11 16.25 11H7.75C7.33582 11 7 11.3358 7 11.75C7 12.1642 7.33582 12.5 7.75 12.5H16.25C16.6642 12.5 17 12.1642 17 11.75Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const RemoveCircleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Remove-circle"
}, "Remove circle"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_189)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17 12C17 11.5858 16.6642 11.25 16.25 11.25H7.75C7.33582 11.25 7 11.5858 7 12C7 12.4142 7.33582 12.75 7.75 12.75H16.25C16.6642 12.75 17 12.4142 17 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_189"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const RestoreIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Restore"
}, "Restore"), /*#__PURE__*/React.createElement("path", {
  d: "M21.4283 11.5C21.4283 7.10411 17.7927 3.54054 13.3079 3.54054C9.14043 3.54054 5.70621 6.61768 5.2411 10.5804L7.5144 8.9565C7.82305 8.73603 8.25058 8.82528 8.46937 9.15585C8.68811 9.48644 8.61524 9.93315 8.30659 10.1536L4.82186 12.6424L4.81898 12.645C4.7058 12.7462 4.56885 12.8004 4.42926 12.8096C4.19164 12.8279 3.94828 12.7148 3.80032 12.4912L1.1732 9.30878C0.921739 9.00449 0.947076 8.55068 1.22976 8.29514C1.51243 8.03954 1.94537 8.07904 2.19683 8.38332L3.70466 10.2081C4.34766 5.57253 8.40214 2 13.3079 2C18.6607 2 23 6.25329 23 11.5C23 16.7467 18.6607 21 13.3079 21C11.5385 21 9.87973 20.535 8.4521 19.7234C8.08599 19.5152 7.99297 19.048 8.22239 18.6994C8.46308 18.3336 8.964 18.2404 9.35159 18.4527C10.5224 19.0942 11.8716 19.4595 13.3079 19.4595C17.7927 19.4595 21.4283 15.8959 21.4283 11.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M13.3116 6.10811C13.7456 6.10811 14.0974 6.45297 14.0974 6.87838V11.6945L17.0107 14.5499C17.3175 14.8507 17.3175 15.3384 17.0107 15.6393C16.7038 15.9401 16.2062 15.9401 15.8993 15.6393L12.5257 12.3326V6.87838C12.5257 6.45297 12.8776 6.10811 13.3116 6.10811Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const RestoreNeededIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Restore-needed"
}, "Restore needed"), /*#__PURE__*/React.createElement("path", {
  d: "M21.4283 11.5C21.4283 7.10411 17.7927 3.54054 13.3079 3.54054C9.14043 3.54054 5.70621 6.61768 5.2411 10.5804L7.5144 8.9565C7.82305 8.73603 8.25058 8.82528 8.46937 9.15585C8.68811 9.48644 8.61524 9.93315 8.30659 10.1536L4.82186 12.6424L4.81898 12.645C4.7058 12.7462 4.56885 12.8004 4.42926 12.8096C4.19164 12.8279 3.94828 12.7148 3.80032 12.4912L1.1732 9.30878C0.921739 9.00449 0.947076 8.55068 1.22976 8.29514C1.51243 8.03954 1.94537 8.07904 2.19683 8.38332L3.70466 10.2081C4.34766 5.57253 8.40214 2 13.3079 2C18.6607 2 23 6.25329 23 11.5C23 16.7467 18.6607 21 13.3079 21C11.5385 21 9.87973 20.535 8.4521 19.7234C8.08599 19.5152 7.99297 19.048 8.22239 18.6994C8.46308 18.3336 8.964 18.2404 9.35159 18.4527C10.5224 19.0942 11.8716 19.4595 13.3079 19.4595C17.7927 19.4595 21.4283 15.8959 21.4283 11.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.2806 12.1857V7.4599C14.2806 7.20532 14.1794 6.96116 13.9994 6.78115C13.8194 6.60113 13.5752 6.5 13.3207 6.5C13.0661 6.5 12.8219 6.60113 12.6419 6.78115C12.4619 6.96116 12.3608 7.20532 12.3608 7.4599V12.1857C12.3608 12.4403 12.4619 12.6845 12.6419 12.8645C12.8219 13.0445 13.0661 13.1456 13.3207 13.1456C13.5752 13.1456 13.8194 13.0445 13.9994 12.8645C14.1794 12.6845 14.2806 12.4403 14.2806 12.1857Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14.0527 14.4551C13.8465 14.2857 13.5879 14.193 13.321 14.1928C13.1695 14.1927 13.0195 14.2225 12.8794 14.2804C12.7394 14.3383 12.6122 14.4232 12.505 14.5303C12.3162 14.7189 12.1986 14.9672 12.1723 15.2328C12.146 15.4984 12.2126 15.7648 12.3608 15.9868C12.509 16.2088 12.7295 16.3725 12.9848 16.4501C13.2402 16.5278 13.5145 16.5144 13.7612 16.4124C14.0078 16.3104 14.2114 16.1261 14.3374 15.8908C14.4633 15.6555 14.5038 15.3838 14.4519 15.122C14.4 14.8603 14.2589 14.6246 14.0527 14.4551Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const RssIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Rss"
}, "Rss"), /*#__PURE__*/React.createElement("path", {
  d: "M7.91146 18.5936C7.91146 19.9139 6.8462 20.9847 5.53105 20.9847C4.21707 20.9847 3.15126 19.9139 3.15126 18.5936C3.15126 17.2715 4.21707 16.2011 5.53105 16.2011C6.8462 16.2011 7.91146 17.2715 7.91146 18.5936Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 11.9577C3 12.2886 3.25769 12.5605 3.58654 12.5774C5.93948 12.698 7.52196 13.5585 8.97946 15.0305C10.4117 16.4755 11.3228 18.5488 11.4792 20.4307C11.506 20.7522 11.7733 21 12.0944 21H14.3063C14.4757 21 14.6378 20.9301 14.7544 20.8066C14.8711 20.6831 14.9321 20.5169 14.9234 20.3468C14.6085 14.1476 9.82615 9.4368 3.6493 9.12722C3.48024 9.11871 3.31523 9.18033 3.19255 9.29749C3.0699 9.41466 3 9.57729 3 9.74737V11.9577Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3 5.83396C3 6.16754 3.26187 6.44083 3.59356 6.45404C11.1695 6.75519 17.259 12.7962 17.5626 20.4038C17.5759 20.7366 17.8482 20.9999 18.1797 20.9999H20.382C20.5496 20.9999 20.71 20.9315 20.8264 20.8104C20.9429 20.6893 21.0053 20.5259 20.9997 20.3576C20.6781 10.7729 13.1823 3.31977 3.63897 3.00034C3.47158 2.99474 3.30915 3.05765 3.18873 3.17466C3.0683 3.29159 3 3.45269 3 3.62097V5.83396Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const SaveIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Save"
}, "Save"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.9342 3.5H4.22222C3.82843 3.5 3.5 3.82843 3.5 4.22222V19.7778C3.5 20.1716 3.82842 20.5 4.22222 20.5H19.7778C20.1716 20.5 20.5 20.1716 20.5 19.7778V7.06577L16.9342 3.5ZM17.1413 2H4.22222C3 2 2 3 2 4.22222V19.7778C2 21 3 22 4.22222 22H19.7778C21 22 22 21 22 19.7778V6.85866C22 6.59344 21.8946 6.33909 21.7071 6.15155L17.8485 2.29289C17.6609 2.10536 17.4066 2 17.1413 2Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 18.5C13.3807 18.5 14.5 17.3807 14.5 16C14.5 14.6193 13.3807 13.5 12 13.5C10.6193 13.5 9.5 14.6193 9.5 16C9.5 17.3807 10.6193 18.5 12 18.5ZM12 20C14.2091 20 16 18.2091 16 16C16 13.7909 14.2091 12 12 12C9.79086 12 8 13.7909 8 16C8 18.2091 9.79086 20 12 20Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6.5 6.5V8.5H15.5V6.5H6.5ZM6 5C5.44772 5 5 5.44772 5 6V9C5 9.55228 5.44772 10 6 10H16C16.5523 10 17 9.55228 17 9V6C17 5.44772 16.5523 5 16 5H6Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const ScheduleIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Schedule"
}, "Schedule"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_187)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.5717 5.77027C12.5717 5.34486 12.2199 5 11.7858 5C11.3518 5 11 5.34486 11 5.77027V13.2245L15.3736 17.5311C15.6804 17.832 16.178 17.832 16.4849 17.5311C16.7918 17.2303 16.7918 16.7426 16.4849 16.4418L12.5717 12.5863V5.77027Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24ZM12 22.5C6.20101 22.5 1.5 17.799 1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_187"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const SearchIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Search"
}, "Search"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M15.5956 16.5403C14.1735 17.6046 12.4005 18.2361 10.4782 18.2361C5.79581 18.2361 2 14.4895 2 9.86803C2 5.24652 5.79581 1.5 10.4782 1.5C15.1606 1.5 18.9564 5.24652 18.9564 9.86803C18.9564 11.8796 18.2372 13.7254 17.0389 15.1686L21.7055 19.8168C22.0981 20.2024 22.0982 20.8268 21.7058 21.2117C21.3133 21.5966 20.677 21.596 20.2845 21.2105L15.5956 16.5403ZM17.4602 9.86803C17.4602 13.674 14.3343 16.7593 10.4782 16.7593C6.62211 16.7593 3.49615 13.674 3.49615 9.86803C3.49615 6.06208 6.62211 2.97671 10.4782 2.97671C14.3343 2.97671 17.4602 6.06208 17.4602 9.86803Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const SendIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Send"
}, "Send"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.7026 2.26298L15.7079 22.2478C15.6063 22.538 15.3378 22.7369 15.0306 22.7494C14.7233 22.7619 14.4395 22.5856 14.3146 22.3046L10.4318 13.5682L1.6954 9.68538C1.41439 9.56049 1.23809 9.27671 1.25063 8.96945C1.26316 8.66219 1.46199 8.39371 1.75224 8.29213L21.7357 1.29792C22.0027 1.19757 22.3155 1.25482 22.5303 1.46967C22.6604 1.59977 22.7327 1.76578 22.7473 1.9358C22.748 1.94445 22.7486 1.95311 22.749 1.96179C22.7508 1.99647 22.7502 2.03138 22.7471 2.06625C22.7463 2.07499 22.7454 2.08372 22.7443 2.09245C22.7372 2.15039 22.7232 2.20766 22.7026 2.26298ZM19.1457 3.79364L4.03331 9.08297L10.8339 12.1055L19.1457 3.79364ZM11.8946 13.1661L14.9171 19.9667L20.2064 4.85424L11.8946 13.1661Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const SettingsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Settings"
}, "Settings"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_153)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.1132 24H10.9685C10.5089 24 10.1209 23.6531 10.0698 23.1939L9.70213 21.0204C8.91574 20.847 8.12936 20.5306 7.39404 20.1021L5.5966 21.4082C5.46383 21.5 5.31064 21.551 5.14723 21.551C5.08596 21.551 4.93277 21.5714 4.74894 21.5204C4.6366 21.4898 4.52426 21.4286 4.43234 21.347L2.84936 19.847C2.84936 19.847 2.78809 19.7857 2.76766 19.7551C2.52255 19.4286 2.52255 18.9796 2.76766 18.6531L4.06468 16.8368C3.58468 16.1327 3.24766 15.3266 3.02298 14.4797L0.755745 14.0919C0.347234 14.0511 0 13.6633 0 13.2041V10.9695C0 10.5103 0.347234 10.1225 0.796596 10.0715L2.95149 9.70417C3.10468 8.90825 3.42128 8.09193 3.85021 7.33684L2.58383 5.53073C2.35915 5.2246 2.35915 4.77563 2.59404 4.4491C2.61447 4.41849 2.63489 4.38788 2.66553 4.36747L4.24851 2.76544C4.32 2.69401 4.41191 2.63278 4.50383 2.59197C4.7183 2.50013 4.91234 2.53074 5.00426 2.53074C5.17787 2.53074 5.32085 2.59197 5.45362 2.69401L7.22043 4.10216C7.89447 3.60217 8.70128 3.25523 9.53872 3.03074L9.94723 0.755244C9.98808 0.561367 10.1004 0.347083 10.2332 0.224635C10.4272 0.0511664 10.6723 -0.0304657 10.9277 0.0103504H13.0519C13.2357 0.0103504 13.5115 0.102187 13.6545 0.234839C13.8179 0.387899 13.92 0.581775 13.9506 0.79606L14.3183 2.96952C15.1353 3.13278 15.9728 3.46951 16.7489 3.91849L18.526 2.65319C18.6587 2.56136 18.8119 2.51034 18.9753 2.51034C19.0264 2.50013 19.2306 2.47972 19.4553 2.57156C19.5472 2.61238 19.6289 2.6634 19.7004 2.74503L21.2426 4.31645C21.2426 4.31645 21.2936 4.36747 21.314 4.39808C21.406 4.53073 21.4877 4.77563 21.4877 4.93889C21.4877 5.13277 21.4264 5.32664 21.314 5.4797L20.017 7.31643C20.497 8.0001 20.834 8.81642 21.0587 9.66335L23.234 10.0001C23.234 10.0001 23.2545 10.0001 23.2647 10.0001C23.4383 10.0409 23.6834 10.1838 23.7957 10.3266C23.9285 10.4899 24 10.694 24 10.898V13.1225C24 13.245 23.9694 13.3572 23.9183 13.4695C23.7549 13.796 23.3974 13.9694 23.0502 13.9592L20.9668 14.3164C20.7932 15.1327 20.446 15.9388 19.9966 16.6939L21.263 18.4796C21.3651 18.6327 21.4468 18.847 21.4468 19.0102C21.4468 19.2653 21.3345 19.5102 21.1506 19.6735L19.6187 21.2143C19.5268 21.2959 19.4247 21.3674 19.3021 21.4082C19.1183 21.4694 18.914 21.4694 18.7302 21.4082C18.6587 21.3878 18.5872 21.347 18.5157 21.3061L16.6877 20C15.9932 20.4898 15.1762 20.8265 14.3285 21.051L13.9915 23.2245C13.9506 23.6327 13.5626 23.9796 13.103 23.9796L13.1132 24ZM12.5004 22.9592C12.5004 22.9592 12.4902 23.0102 12.4902 23.0408V22.9592H12.5004ZM11.5915 22.9286V22.9898C11.5915 22.9898 11.5915 22.949 11.5915 22.9286ZM11.5098 22.4694H12.5821L12.8681 20.7653C12.9089 20.4898 13.0417 20.2245 13.2357 20.0102C13.4298 19.7959 13.6851 19.6531 13.9609 19.5817C14.6655 19.398 15.3396 19.1123 15.9728 18.7347C16.4221 18.449 17.0757 18.4388 17.5557 18.7347L18.9549 19.7347L19.7311 18.9592L18.72 17.5307C18.5464 17.2551 18.4647 16.9796 18.4647 16.7041C18.4647 16.4286 18.5464 16.1531 18.6894 15.9082C19.057 15.2858 19.343 14.6123 19.5268 13.898C19.5881 13.6327 19.7413 13.3776 19.9557 13.1735C20.1702 12.9797 20.4357 12.847 20.7319 12.8062L22.4783 12.5103V11.4286L20.783 11.1429C20.5072 11.1021 20.2417 10.9695 20.0272 10.7756C19.8128 10.5817 19.6698 10.3266 19.5983 10.0409C19.4145 9.34703 19.1285 8.66336 18.7506 8.03071C18.6179 7.81642 18.5362 7.54092 18.5362 7.2552C18.5362 6.96949 18.6179 6.69398 18.7711 6.45929L19.8026 5.01032L19.0162 4.2042L17.617 5.2042C17.0655 5.55113 16.463 5.53072 15.983 5.2246C15.36 4.86746 14.6553 4.58175 13.9302 4.40828C13.6545 4.34706 13.3991 4.194 13.2051 3.97971C13.0111 3.76543 12.8783 3.50012 12.8374 3.20421L12.5515 1.53075H11.3974L11.1013 3.25523C11.0809 3.51033 10.9481 3.80625 10.7438 4.04094C10.5294 4.27563 10.2536 4.43889 9.94723 4.51032C9.27319 4.694 8.59915 4.97971 7.96596 5.35726C7.53702 5.63277 6.85277 5.65317 6.37277 5.33685L4.98383 4.23481L4.17702 5.05114L5.18809 6.4797C5.3617 6.75521 5.4434 7.03072 5.4434 7.30622C5.4434 7.58173 5.3617 7.85724 5.21872 8.10214C4.8817 8.70417 4.61617 9.38784 4.44255 10.0919C4.38128 10.3776 4.22809 10.6327 4.01362 10.8266C3.79915 11.0307 3.53362 11.1531 3.23745 11.194L1.57277 11.4797V12.6531L3.28851 12.9388C3.55404 12.9695 3.85021 13.0919 4.08511 13.3062C4.32 13.5103 4.4834 13.7858 4.55489 14.1021C4.73872 14.7858 5.02468 15.4694 5.39234 16.1021C5.53532 16.3062 5.61702 16.5919 5.61702 16.8776C5.61702 17.1633 5.53532 17.449 5.37192 17.6939L4.36085 19.1123L5.15745 19.8674L6.58723 18.847C6.83234 18.6633 7.15915 18.5613 7.46553 18.5715C7.73106 18.5715 7.9966 18.6429 8.23149 18.7959C8.81362 19.1327 9.47745 19.4082 10.1719 19.5817C10.4374 19.6429 10.6928 19.7959 10.897 20.0102C11.0911 20.2245 11.2238 20.4898 11.2647 20.7755L11.5506 22.4592L11.5098 22.4694ZM4.03404 19.5306L4.01362 19.551C4.01362 19.551 4.02383 19.5408 4.03404 19.5306ZM0.970213 12.5715H1.05191C1.05191 12.5715 1.00085 12.5715 0.970213 12.5715ZM1.07234 11.5715H1.01106C1.01106 11.5715 1.05191 11.5715 1.07234 11.5715ZM3.84 4.63277L3.86043 4.65318C3.86043 4.65318 3.85021 4.63277 3.84 4.63277ZM13.0009 1.55116C13.0519 1.55116 13.103 1.55116 13.1643 1.55116H13.0009ZM11.9898 16.8368C11.04 16.8368 10.1209 16.5613 9.32425 16.0307C8.52766 15.5001 7.91489 14.7552 7.54723 13.8674C7.17957 12.9797 7.08766 12.0205 7.27149 11.0817C7.45532 10.1429 7.91489 9.2858 8.58894 8.61234C9.26298 7.93887 10.1209 7.47969 11.0604 7.29602C12 7.11235 12.96 7.20418 13.8485 7.57153C14.7268 7.93887 15.4723 8.55111 16.0034 9.35723C16.5345 10.1531 16.8102 11.0817 16.8102 12.0409C16.8102 13.3164 16.3098 14.5205 15.4009 15.4286C14.5021 16.3368 13.297 16.8368 12.0204 16.8368H12H11.9898ZM12 15.3062C12.8681 15.3062 13.6851 14.9592 14.3081 14.347C14.9311 13.7348 15.2681 12.9082 15.2681 12.0409C15.2681 11.3878 15.0843 10.7552 14.7166 10.2144C14.3591 9.67356 13.8485 9.25519 13.246 9.00009C12.6434 8.74499 11.9898 8.68377 11.3464 8.80622C10.703 8.92866 10.1311 9.24499 9.66128 9.70417C9.2017 10.1633 8.88511 10.745 8.76255 11.3878C8.64 12.0307 8.70128 12.6837 8.9566 13.2858C9.21192 13.8878 9.63064 14.398 10.1719 14.7552C10.7132 15.1123 11.3362 15.3062 11.9796 15.3062H11.9898H12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_153"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const ShareIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Share"
}, "Share"), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_2_101)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.5 8C19.7091 8 21.5 6.20914 21.5 4C21.5 1.79086 19.7091 0 17.5 0C15.2909 0 13.5 1.79086 13.5 4C13.5 4.50715 13.5944 4.99226 13.7665 5.43871L7.62692 8.98342C6.92418 8.37094 6.00541 8 5 8C2.79086 8 1 9.79086 1 12C1 14.2091 2.79086 16 5 16C6.07108 16 7.04383 15.579 7.76183 14.8935L13.5707 18.2473C13.5243 18.4911 13.5 18.7427 13.5 19C13.5 21.2091 15.2909 23 17.5 23C19.7091 23 21.5 21.2091 21.5 19C21.5 16.7909 19.7091 15 17.5 15C16.0866 15 14.8444 15.7331 14.1329 16.8398L8.63722 13.6669C8.87014 13.1594 9 12.5949 9 12C9 11.343 8.84162 10.7231 8.56097 10.1762L14.5602 6.71253C15.291 7.5042 16.3376 8 17.5 8ZM17.5 6.5C18.8807 6.5 20 5.38071 20 4C20 2.61929 18.8807 1.5 17.5 1.5C16.1193 1.5 15 2.61929 15 4C15 5.38071 16.1193 6.5 17.5 6.5ZM17.5 21.5C18.8807 21.5 20 20.3807 20 19C20 17.6193 18.8807 16.5 17.5 16.5C16.1193 16.5 15 17.6193 15 19C15 20.3807 16.1193 21.5 17.5 21.5ZM7.5 12C7.5 13.3807 6.38071 14.5 5 14.5C3.61929 14.5 2.5 13.3807 2.5 12C2.5 10.6193 3.61929 9.5 5 9.5C6.38071 9.5 7.5 10.6193 7.5 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
})), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_2_101"
}, /*#__PURE__*/React.createElement("rect", {
  width: 24,
  height: 24,
  fill: "white"
}))));
export const ShowIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Show"
}, "Show"), /*#__PURE__*/React.createElement("path", {
  d: "M22.957 12.2561C22.0934 10.0702 20.5795 8.20209 18.62 6.9044C16.6604 5.60672 14.3496 4.94199 12 5.00009C9.6504 4.94199 7.33961 5.60672 5.38003 6.9044C3.42044 8.20209 1.90654 10.0702 1.04299 12.2561C0.98575 12.4134 0.98575 12.5858 1.04299 12.7431C1.90626 14.9293 3.42006 16.7977 5.37969 18.0955C7.33932 19.3934 9.65025 20.0583 12 20.0001C14.3496 20.0582 16.6604 19.3935 18.62 18.0958C20.5795 16.7981 22.0934 14.93 22.957 12.7441C23.0142 12.5865 23.0142 12.4137 22.957 12.2561ZM12 18.5001C10.0164 18.55 8.06334 18.0052 6.39192 16.936C4.7205 15.8667 3.40721 14.3218 2.62099 12.5001C3.40732 10.6784 4.72064 9.13362 6.39203 8.06438C8.06343 6.99514 10.0165 6.45036 12 6.50009C13.9835 6.45022 15.9366 6.99495 17.6081 8.06421C19.2795 9.13346 20.5928 10.6783 21.379 12.5001C20.5927 14.3218 19.2793 15.8666 17.608 16.9358C15.9366 18.005 13.9835 18.5498 12 18.5001Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12 8.15109C10.7974 8.10445 9.83665 8.53568 8.95094 9.35056C8.06523 10.1654 7.76504 11.2977 7.71152 12.5001C7.81065 13.6854 8.12454 14.7903 8.99999 15.5956C9.87543 16.4009 10.81 16.8478 11.9995 16.8478C13.189 16.8478 14.3351 16.4009 15.2105 15.5956C16.086 14.7903 16.6269 13.6854 16.726 12.5001C16.6725 11.2979 16.1454 10.1658 15.2599 9.35092C14.3744 8.53607 13.2025 8.10472 12 8.15109ZM12 15.3991C11.437 15.3521 10.8998 15.1421 10.4541 14.7949C10.0084 14.4477 9.67352 13.9782 9.49026 13.4437C9.30701 12.9093 9.28335 12.333 9.42218 11.7854C9.56101 11.2377 9.85632 10.7423 10.272 10.3597C10.6878 9.97711 11.2059 9.72384 11.7632 9.63085C12.3205 9.53785 12.8928 9.60915 13.4102 9.83604C13.9276 10.0629 14.3678 10.4356 14.6769 10.9085C14.986 11.3814 15.1508 11.9341 15.151 12.4991C15.1157 13.3008 14.7644 14.0559 14.1739 14.5993C13.5834 15.1427 12.8019 15.4303 12 15.3991Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const SigninIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Signin"
}, "Signin"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M19.4605 0C20.9793 0 22.2105 1.21852 22.2105 2.72165V21.2784C22.2105 22.7815 20.9793 24 19.4605 24H10.4605C10.0463 24 9.71054 23.6677 9.71054 23.2577C9.71054 22.8478 10.0463 22.5155 10.4605 22.5155H19.4605C20.1509 22.5155 20.7105 21.9616 20.7105 21.2784V2.72165C20.7105 2.03841 20.1509 1.48454 19.4605 1.48454H10.4605C10.0463 1.48454 9.71054 1.15221 9.71054 0.742268C9.71054 0.332325 10.0463 0 10.4605 0H19.4605ZM2.63053 12.8892C2.16604 12.8892 1.78949 12.5109 1.78949 12.0441C1.78949 11.5774 2.16604 11.1991 2.63054 11.1991L12.9177 11.1991L9.39918 7.66547C9.07147 7.3347 9.07267 6.79962 9.40186 6.47034C9.73105 6.14106 10.2636 6.14227 10.5913 6.47304L15.5426 11.4529C15.7223 11.6342 15.8031 11.8769 15.7852 12.1134C15.802 12.3501 15.7202 12.5925 15.5397 12.773L10.3726 17.925C10.0434 18.2543 9.51091 18.2531 9.18321 17.9223C8.8555 17.5915 8.8567 17.0565 9.18589 16.7272L12.917 12.8892L2.63053 12.8892Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const SignoutIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Signout"
}, "Signout"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M6 0C4.48122 0 3.25 1.21852 3.25 2.72165V21.2784C3.25 22.7815 4.48122 24 6 24H15C15.4142 24 15.75 23.6677 15.75 23.2577C15.75 22.8478 15.4142 22.5155 15 22.5155H6C5.30964 22.5155 4.75 21.9616 4.75 21.2784V2.72165C4.75 2.03841 5.30964 1.48454 6 1.48454H15C15.4142 1.48454 15.75 1.15221 15.75 0.742268C15.75 0.332325 15.4142 0 15 0H6ZM7.8429 12.8892C7.37841 12.8892 7.00186 12.5109 7.00186 12.0441C7.00186 11.5774 7.37841 11.1991 7.84291 11.1991L18.1301 11.1991L14.6115 7.66547C14.2838 7.3347 14.285 6.79962 14.6142 6.47034C14.9434 6.14106 15.4759 6.14227 15.8036 6.47304L20.755 11.4529C20.9346 11.6342 21.0154 11.8769 20.9976 12.1134C21.0144 12.3501 20.9325 12.5925 20.752 12.773L15.585 17.925C15.2558 18.2543 14.7233 18.2531 14.3956 17.9223C14.0679 17.5915 14.0691 17.0565 14.3983 16.7272L18.1294 12.8892L7.8429 12.8892Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const StopWatchIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Stop-watch"
}, "Stop watch"), /*#__PURE__*/React.createElement("path", {
  d: "M16.0365 9.38051C16.3253 9.70994 16.2924 10.2111 15.963 10.4999L12.5548 13.488C12.2253 13.7768 11.7241 13.7439 11.4353 13.4145C11.1465 13.085 11.1794 12.5838 11.5089 12.295L14.9171 9.30697C15.2465 9.01816 15.7477 9.05108 16.0365 9.38051Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.5817 1.19995C14.0198 1.19995 14.3749 1.55511 14.3749 1.99322C14.3749 2.43133 14.0198 2.78649 13.5817 2.78649L12.0481 2.78649V4.17598C17.0594 4.45038 21.0384 8.60089 21.0384 13.6807C21.0384 18.9381 16.7765 23.2 11.5192 23.2C6.26189 23.2 2 18.9381 2 13.6807C2 8.78094 5.70197 4.74577 10.4615 4.21963V2.78649L8.82205 2.78649C8.38394 2.78649 8.02878 2.43133 8.02878 1.99322C8.02878 1.55511 8.38394 1.19995 8.82205 1.19995H13.5817ZM11.5192 21.6134C15.9003 21.6134 19.4519 18.0618 19.4519 13.6807C19.4519 9.29965 15.9003 5.74807 11.5192 5.74807C7.13811 5.74807 3.58653 9.29965 3.58653 13.6807C3.58653 18.0618 7.13811 21.6134 11.5192 21.6134Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M22.0916 7.92024C22.3278 8.43778 21.9127 8.98699 21.3442 8.96714C21.0168 8.9557 20.7307 8.74964 20.5896 8.45397C19.8881 6.98431 18.7464 5.75998 17.3293 4.95771C17.0442 4.79631 16.8586 4.49659 16.87 4.16916C16.8899 3.60065 17.4667 3.22492 17.9665 3.49657C19.7815 4.48305 21.2342 6.04083 22.0916 7.92024Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const SystemIdIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-System-id"
}, "System id"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.6744 7C11.6528 7 11.6317 7.00562 11.6106 7.01125L10.2232 7.38251C10.1927 7.39047 10.1655 7.40454 10.1407 7.42376C10.1158 7.44298 10.0929 7.46407 10.0769 7.49126C10.061 7.51844 10.0511 7.55032 10.0469 7.58126C10.0427 7.61219 10.0455 7.64454 10.0544 7.67501L10.3694 8.85251C10.039 9.03625 9.73193 9.2711 9.46193 9.55001L8.40443 8.93875C8.37724 8.92328 8.34912 8.91297 8.31818 8.90875C8.28724 8.90453 8.2549 8.90734 8.22443 8.91625C8.19396 8.92422 8.16677 8.93828 8.14193 8.9575C8.11709 8.97672 8.09365 9.00156 8.07818 9.02875L7.36192 10.27C7.34599 10.2972 7.33614 10.3291 7.33192 10.36C7.32771 10.391 7.32771 10.4233 7.33567 10.4538C7.34364 10.4842 7.35771 10.5114 7.37692 10.5363C7.39614 10.5611 7.42099 10.5803 7.44817 10.5963L8.50567 11.2075C8.39927 11.5807 8.35005 11.9622 8.35567 12.34L7.17817 12.6588C7.14771 12.6667 7.11677 12.6808 7.09192 12.7C7.06708 12.7192 7.04739 12.7403 7.03192 12.7675C7.01646 12.7947 7.00614 12.8266 7.00192 12.8575C6.99771 12.8885 7.00052 12.9208 7.00942 12.9513L7.38068 14.3387C7.38865 14.3692 7.40271 14.3964 7.42193 14.4212C7.44115 14.4461 7.46599 14.4695 7.49318 14.485C7.52037 14.5009 7.54849 14.5107 7.57943 14.515C7.61037 14.5192 7.64271 14.515 7.67318 14.5075L8.85068 14.1925C9.03442 14.5229 9.26928 14.8267 9.54818 15.0962L8.93692 16.1537C8.92099 16.1809 8.91114 16.2128 8.90692 16.2437C8.90271 16.2747 8.90552 16.307 8.91442 16.3375C8.92239 16.3679 8.93645 16.3951 8.95567 16.42C8.97489 16.4448 8.99599 16.464 9.02317 16.48L10.2682 17.2C10.2954 17.2154 10.3272 17.2257 10.3582 17.23C10.3891 17.2342 10.4215 17.23 10.4519 17.2225C10.4824 17.2145 10.5096 17.2004 10.5344 17.1812C10.5593 17.162 10.5827 17.1371 10.5982 17.11L11.2057 16.0562C11.5783 16.1626 11.9599 16.2123 12.3382 16.2062L12.6532 17.3837C12.6611 17.4142 12.6752 17.4414 12.6944 17.4662C12.7136 17.4911 12.7385 17.5145 12.7657 17.53C12.7929 17.5454 12.8247 17.5557 12.8557 17.56C12.8866 17.5642 12.919 17.56 12.9494 17.5525L14.3369 17.1812C14.3673 17.1732 14.3945 17.1592 14.4194 17.14C14.4442 17.1207 14.4639 17.0959 14.4794 17.0687C14.4953 17.0415 14.5051 17.0139 14.5094 16.9825C14.5136 16.9511 14.5136 16.9192 14.5056 16.8887L14.1869 15.7112C14.5187 15.5275 14.8234 15.2931 15.0944 15.0137L16.1519 15.625C16.1791 15.6409 16.2109 15.6508 16.2419 15.655C16.2728 15.6592 16.3052 15.655 16.3356 15.6475C16.3661 15.6395 16.3933 15.6254 16.4181 15.6062C16.443 15.587 16.4659 15.5622 16.4819 15.535L17.1981 14.2937C17.2136 14.2665 17.2239 14.2346 17.2281 14.2037C17.2323 14.1728 17.2295 14.1404 17.2206 14.1099C17.2127 14.0795 17.1986 14.0523 17.1794 14.0274C17.1602 14.0026 17.1391 13.9796 17.1119 13.9637L16.0544 13.3524C16.1603 12.9817 16.2067 12.6034 16.2006 12.2274L17.3819 11.9049C17.4119 11.8965 17.4395 11.8829 17.4644 11.8637C17.4892 11.8445 17.5127 11.8196 17.5281 11.7924C17.5436 11.7652 17.5539 11.7371 17.5581 11.7062C17.5624 11.6752 17.5595 11.6429 17.5506 11.6124L17.1794 10.225C17.1714 10.1945 17.1574 10.1673 17.1381 10.1425C17.1189 10.1177 17.0941 10.0942 17.0669 10.0787C17.0397 10.0633 17.0078 10.053 16.9769 10.0487C16.9459 10.0445 16.9136 10.0473 16.8831 10.0562L15.7056 10.3712C15.5219 10.0412 15.2908 9.73374 15.0119 9.46374L15.6194 8.40624C15.6349 8.37906 15.6452 8.35093 15.6494 8.31999C15.6536 8.28906 15.6536 8.25671 15.6456 8.22624C15.6377 8.19577 15.6236 8.16484 15.6044 8.13999C15.5852 8.11515 15.5603 8.09593 15.5331 8.07999L14.2919 7.36374C14.2647 7.3478 14.2328 7.33796 14.2019 7.33374C14.1709 7.32952 14.1386 7.32952 14.1081 7.33749C14.0776 7.34546 14.0505 7.35952 14.0256 7.37874C14.0008 7.39796 13.9773 7.4228 13.9619 7.44999L13.3544 8.50749C12.9812 8.40108 12.5964 8.35139 12.2181 8.35749L11.9031 7.17999C11.8895 7.12983 11.8619 7.08436 11.8206 7.05249C11.7794 7.02061 11.7264 7.00047 11.6744 7ZM12.2856 9.85744C12.6958 9.85744 13.1134 9.96103 13.4931 10.1799C14.6504 10.8488 15.0456 12.3375 14.3781 13.4949C13.7106 14.6523 12.2242 15.0475 11.0668 14.3799C9.90945 13.711 9.50919 12.2261 10.178 11.0687C10.6266 10.2919 11.4456 9.85648 12.2856 9.85744Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22 2C23.1046 2 24 2.89543 24 4V20C24 21.1046 23.1046 22 22 22L2 22C0.895429 22 0 21.1046 0 20V4C0 2.89543 0.895432 2 2 2H22ZM22.5 4V20C22.5 20.2761 22.2761 20.5 22 20.5L2 20.5C1.72386 20.5 1.5 20.2761 1.5 20L1.5 4C1.5 3.72386 1.72386 3.5 2 3.5L22 3.5C22.2761 3.5 22.5 3.72386 22.5 4Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const TableActionIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Table-action"
}, "Table action"), /*#__PURE__*/React.createElement("path", {
  d: "M6 14C7.10457 14 8 13.1046 8 12C8 10.8954 7.10457 10 6 10C4.89543 10 4 10.8954 4 12C4 13.1046 4.89543 14 6 14Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20 12C20 13.1046 19.1046 14 18 14C16.8954 14 16 13.1046 16 12C16 10.8954 16.8954 10 18 10C19.1046 10 20 10.8954 20 12Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const UploadIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-Upload"
}, "Upload"), /*#__PURE__*/React.createElement("path", {
  d: "M2 21.2502C2 20.8359 2.33579 20.5002 2.75 20.5002H21.25C21.6642 20.5002 22 20.8359 22 21.2502C22 21.6644 21.6642 22.0002 21.25 22.0002H2.75C2.33579 22.0002 2 21.6644 2 21.2502Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.2416 16.9981C12.6387 16.9981 12.9606 16.6843 12.9606 16.2971L12.9606 4.39047L16.2255 7.50008C16.5056 7.77443 16.9608 7.77543 17.2422 7.50232C17.5236 7.2292 17.5246 6.78539 17.2445 6.51103L12.8617 2.2047C12.7081 2.05429 12.5019 1.98603 12.3006 2.00007C12.0994 1.98518 11.8929 2.05252 11.7387 2.20223L7.5023 6.3288C7.22091 6.60192 7.21988 7.04573 7.5 7.32008C7.78012 7.59444 8.23531 7.59544 8.5167 7.32232L11.5227 4.38992L11.5227 16.2971C11.5227 16.6843 11.8446 16.9981 12.2416 16.9981Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.75012 17.0001C3.16434 17.0001 3.50012 17.3359 3.50012 17.7501L3.50012 21.2501C3.50012 21.6643 3.16422 22.0002 2.75 22.0002C2.33579 22.0002 2 21.6644 2 21.2502L2.00012 17.7501C2.00012 17.3359 2.33591 17.0001 2.75012 17.0001Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M21.2501 17.0001C21.6643 17.0001 22.0001 17.3359 22.0001 17.7501L22 21.2502C22 21.6644 21.6642 22.0002 21.25 22.0002C20.8358 22.0002 20.5001 21.6643 20.5001 21.2501V17.7501C20.5001 17.3359 20.8359 17.0001 21.2501 17.0001Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const UserIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-User"
}, "User"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM19.6016 17.6987C20.7937 16.1112 21.5 14.1381 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 14.1556 3.21792 16.1435 4.42771 17.7376C5.53225 15.1131 7.48122 13.131 9.8228 12.3561C8.72559 11.6429 8 10.4062 8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 10.3996 15.2812 11.6313 14.1925 12.3461C16.5361 13.11 18.4894 15.0822 19.6016 17.6987ZM18.4227 19H18.3222C18.3334 18.9799 18.3427 18.9615 18.3506 18.9449C17.1938 15.7065 14.6927 13.6936 12.0229 13.6936C9.33799 13.6936 6.82366 15.7293 5.67567 19H5.59018C5.58667 18.9888 5.58363 18.9829 5.58363 18.9829C5.58363 18.9829 5.58456 18.9883 5.59018 19H5.5773C7.26834 20.5524 9.52351 21.5 12 21.5C14.4765 21.5 16.7317 20.5524 18.4227 19ZM12 11.5C13.3807 11.5 14.5 10.3807 14.5 9C14.5 7.61929 13.3807 6.5 12 6.5C10.6193 6.5 9.5 7.61929 9.5 9C9.5 10.3807 10.6193 11.5 12 11.5Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));
export const UserSettingsIcon = ({
  color,
  size,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props, {
  style: resolveParams(color, size, props?.style)
}), /*#__PURE__*/React.createElement("desc", {
  id: "-User-settings"
}, "User settings"), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M9.1616 13.5848C8.25695 14.129 7.66227 14.9955 7.41398 16.4185C8.87095 17.4802 10.4096 17.9847 12.0624 17.9847C13.741 17.9847 15.2389 17.5201 16.5956 16.5791C16.4802 15.6861 16.1021 14.3824 14.9847 13.6092C14.0418 14.0914 12.9759 14.29 11.9809 14.29C10.7727 14.29 9.78533 13.908 9.1616 13.5848ZM18.125 16.8028C18.0523 15.7784 17.6481 13.3968 15.502 12.1633C15.1546 11.9637 14.7298 12.044 14.3772 12.2342C13.672 12.6143 12.82 12.79 11.9809 12.79C11.0445 12.79 10.2694 12.478 9.78678 12.2187C9.43891 12.0317 9.0169 11.9591 8.66723 12.1426C7.06705 12.9826 6.16134 14.4293 5.88146 16.5171C5.83492 16.8643 5.97885 17.2094 6.25562 17.424C8.02717 18.7978 9.96276 19.4847 12.0624 19.4847C14.172 19.4847 16.0692 18.8541 17.754 17.5928C18.0032 17.4063 18.147 17.1133 18.125 16.8028Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 10.5362C13.2484 10.5362 14.2605 9.52415 14.2605 8.27573C14.2605 7.02731 13.2484 6.01526 12 6.01526C10.7515 6.01526 9.7395 7.0273 9.7395 8.27573C9.7395 9.52416 10.7515 10.5362 12 10.5362ZM15.7605 8.27573C15.7605 10.3526 14.0768 12.0362 12 12.0362C9.92312 12.0362 8.2395 10.3526 8.2395 8.27573C8.2395 6.19888 9.92312 4.51526 12 4.51526C14.0768 4.51526 15.7605 6.19888 15.7605 8.27573Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M12 22.5C17.799 22.5 22.5 17.799 22.5 12C22.5 6.20101 17.799 1.5 12 1.5C6.20101 1.5 1.5 6.20101 1.5 12C1.5 17.799 6.20101 22.5 12 22.5ZM12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
  id: "base-layer",
  fill: "var(--icon-primary)"
}));